import { useIntl, FormattedMessage } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { download } from '@cld/file-download';
import { AssetMetadataVertical } from '@cld/asset-metadata';
import Button, { ButtonMenu } from '@cld/button';
import CopyToClipboard from '@cld/copy-to-clipboard';
import Icon from '@cld/icon';
import { usePhone } from '@cld/style-utils';
import theme from '@cld/theme-helper';

import { messages } from '../../i18n';

const Root = styled.header`
  display: flex;
  align-items: center;
  padding: ${theme`spacing.md`};
  background-color: ${theme`color.white`};
`;

const Actions = styled.div`
  align-items: center;
  display: flex;
  margin-left: auto;

  ${Button} {
    margin-right: ${theme`spacing.xs`};
  }
`;

export const Header = ({ asset, onClose }) => {
  const { formatMessage } = useIntl();
  const isPhone = usePhone();

  const downloadAsset = () => download(asset.urls.originalDownload);

  return (
    <Root>
      <AssetMetadataVertical
        type={asset.type}
        filename={asset.filename}
        bytes={asset.bytes}
        height={asset.height}
        width={asset.width}
        duration={asset.duration}
        color="gray80"
      />

      {asset.urls.originalDownload && (
        <Actions>
          <CopyToClipboard copiedValue={asset.urls.original} tooltipAfterText={formatMessage(messages.assetCopyUrlSuccess)}>
            <Button variant="secondary" data-test="copy-button">
              <Icon name="fetch" />
              {!isPhone && <FormattedMessage {...messages.assetCopyUrl} />}
            </Button>
          </CopyToClipboard>

          <Button variant="secondary" onClick={downloadAsset} data-test="download-button">
            <Icon name="fileDownload" />
            {!isPhone && <FormattedMessage {...messages.assetDownload} />}
          </Button>

          <ButtonMenu onClick={onClose} data-test="close-button">
            <Icon name="cross" />
          </ButtonMenu>
        </Actions>
      )}
    </Root>
  );
};

export const HeaderHeight = {
  desktop: 76,
  phone: 70,
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired,
};
